<div class="content">
  <mat-icon class="prefix-icon" fontIcon="block"></mat-icon>
  <span class="message" transloco="LOCAL_NETWORK_ACCESS_BLOCKED_SNACKBAR_MSG"></span>
</div>
<div class="actions">
  <button matButton (click)="moreInfo()">
    <span transloco="MORE_INFO" aria-label="more info"></span>
  </button>
  <button matButton (click)="dismiss()">
    <span transloco="DISMISS"></span>
  </button>
</div>
